module.exports = __webpack_public_path__ + "static/media/Horizon_Outlined.09c45e09.otf";